(ns admin.events.containers.curriculum-activities
  "Responsible for bootstrapping the new-curriclum & edit-curriculum activities page"
  (:require [clojure.set :refer [rename-keys]]
            [kyber.router :refer [ensure-resource-v2]]
            [kyber.events.eql :as eql]
            [kyber.events.utils :refer [kyber-event-fx]]
            [re-frame.core :as re-frame]
            [kyber.lib.kyber-db :as kyber-db]))

(when ^boolean js/goog.DEBUG
  (def event-doc-get-user-curriculum-roles-success
    {:description "Get user (in session) curriculum roles (Success)"
     :changelog
     [{:date "18MAY21"
       :event-version 0
       :data {}}]}))

(defn get-user-curriculum-roles-success
  [{:keys [db]} [event-name _params {:app.current-session/keys [user]}]]
  (let [current-user (-> user 
                         (rename-keys {:>/curriculum :current-user/curriculum-roles 
                                       :user/super-user? :current-user/super-user?})
                         (assoc :current-user/id "current-user"))
        curriculum-roles (get-in current-user [:current-user/curriculum-roles :user/curriculum-roles])]
    {:db (kyber-db/tx-record db {:model :current-user} (assoc current-user :current-user/curriculum-roles curriculum-roles))
     :dispatch-n [[:analytics/save-datapoint {:event event-name
                                              :event-version 0}]]}))

(kyber-event-fx ::get-user-curriculum-roles-success get-user-curriculum-roles-success)

(when ^boolean js/goog.DEBUG
  (def event-doc-get-user-curriculum-roles-failure
    {:description "Get user (in session) curriculum roles (Failure)"
     :changelog
     [{:date "18MAY21"
       :event-version 0
       :data {}}]}))

(defn get-user-curriculum-roles-failure
  [{:keys [db]} [event-name _ _err]]
  {:db db
   :dispatch-n [[:analytics/save-datapoint {:event event-name
                                            :event-version 0}]]})

(kyber-event-fx ::get-user-curriculum-roles-failure get-user-curriculum-roles-failure)

(when ^boolean js/goog.DEBUG
  (def event-doc-get-user-curriculum-roles
    {:description "Get user (in session) curriculum roles"
     :changelog
     [{:date "18MAY21"
       :event-version 0
       :data {}}]}))

(defn get-user-curriculum-roles
  [{:keys [db]} [event-name {:keys [curriculum-uuid] :as params}]]
  {:db db
   :dispatch-n [[:analytics/save-datapoint {:event event-name
                                            :event-version 0}]]
   :request
   (eql/request
    db
    {:name event-name
     :params `[{:app.current-session/user
                [:user/super-user?
                 {(:>/curriculum {:curriculum/uuid ~curriculum-uuid})
                  [:curriculum/uuid
                   :user/curriculum-roles]}]}]
     :on-success [::get-user-curriculum-roles-success params]
     :on-failure [::get-user-curriculum-roles-failure params]})})

(kyber-event-fx ::get-user-curriculum-roles get-user-curriculum-roles)

(when ^boolean js/goog.DEBUG
  (def event-doc-fetch-container-data-success
    {:description "Get curriculum activities page (Success)"
     :changelog
     [{:date "18MAY21"
       :event-version 0
       :data {}}]}))

(defn fetch-container-data-success
  [{:keys [db]} [event-name _params res]]
  {:db (kyber-db/tx-record db {:model :curriculum} (:>/curriculum res))
   :dispatch-n [[:analytics/save-datapoint {:event event-name
                                            :event-version 0}]]})

(kyber-event-fx ::fetch-container-data-success fetch-container-data-success)

(when ^boolean js/goog.DEBUG
  (def event-doc-fetch-container-data-failure
    {:description "Get curriculum activities page (Failure)"
     :changelog
     [{:date "18MAY21"
       :event-version 0
       :data {}}]}))

(defn fetch-container-data-failure
  [{:keys [db]} [event-name _ _err]]
  {:db db
   :dispatch-n [[:analytics/save-datapoint {:event event-name
                                            :event-version 0}]]})

(kyber-event-fx ::fetch-container-data-failure fetch-container-data-failure)

(when ^boolean js/goog.DEBUG
  (def event-doc-fetch-container-data
    {:description "Get curriculum activities page"
     :changelog
     [{:date "18MAY21"
       :event-version 0
       :data {}}]}))

(defn fetch-container-data
  [{:keys [db]} [event-name {:keys [curriculum-uuid] :as params}]]
  {:db db
   :dispatch-n [[:analytics/save-datapoint {:event event-name
                                            :event-version 0}]]
   :request
   (eql/request
    db
    {:name event-name
     :params `[{(:>/curriculum {:curriculum/uuid ~curriculum-uuid})
                [:curriculum/uuid
                 :curriculum/name
                 :curriculum/clp-enabled
                 :curriculum/pre-registration-enabled?]}]
     :on-success [::fetch-container-data-success params]
     :on-failure [::fetch-container-data-failure params]})})

(kyber-event-fx ::fetch-container-data fetch-container-data)

(def ensure-curriculum-activities
  ""
  (partial ensure-resource-v2
           ::fetch-container-data
           #(re-frame/dispatch [::fetch-container-data %])))

(def ensure-curriculum-roles
  ""
  (partial ensure-resource-v2
           ::get-user-curriculum-roles
           #(re-frame/dispatch [::get-user-curriculum-roles %])))
